import { render, staticRenderFns } from "./singlesodetail.vue?vue&type=template&id=62fdfb7c&scoped=true&"
import script from "./singlesodetail.vue?vue&type=script&lang=js&"
export * from "./singlesodetail.vue?vue&type=script&lang=js&"
import style0 from "./singlesodetail.vue?vue&type=style&index=0&id=62fdfb7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdfb7c",
  null
  
)

export default component.exports